// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_admin_admin_module_ts":"058c78e3b879faac148b","node_modules_dompurify_dist_purify_js":"39199faa625f3f787455","node_modules_canvg_lib_index_es_js":"5670149c68a937c8051d","src_app_admin_dashboard_dashboard_module_ts":"3e085afe524ba7fc35cd"}[chunkId] + ".js";
};